import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

//- material-ui
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
//import OpenLink from '@material-ui/icons/OpenInNew';

//- Container
import PricingRequestContainer from '../../containers/retailPricing/PricingRequest';
import GasBuddyPricesContainer from '../../containers/reports/GasBuddyPrices';

// Form / UI
import FormComponent from '../../components/FormComponent';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';
import FMPText from '../../components/pureForm/FMPText';
import FMPRegionHeader from '../../components/ui/FMPRegionHeader';
import { getSharedStyles } from '../../themes';
import GenericSavingDialog from '../../components/Dialogs/GenericSavingDialog';

import GreenChecked from '../../images/icons/greenChecked.svg';
import YellowWarning from '../../images/icons/yellowWarning.svg';
import ErrorIcon from '../../images/icons/error.svg';
import { Popover } from '@material-ui/core';

// const pBlue = '#0790CB';
const styles = (theme) => ({
	...getSharedStyles(theme),
	paper: {
		width: '100%',
		overflowX: 'auto',
		textAlign: 'left',
		boxSizing: 'border-box',
		padding: 20,
		[theme.breakpoints.up('md')]: {
			padding: '30px 30px 30px 30px',
		},
	},
	commentsContainer: {
		padding: 7,
		display: 'inline-block',
		fontSize: '90%',
		maxWidth: '400px',
	},
	sectionLabel: {
		textTransform: 'uppercase',
		color: '#777',
		marginBottom: 2,
		fontSize: '85%',
		letterSpacing: '1px',
	},
	greenCheckedIconSmall: {
		backgroundImage: `url('${GreenChecked}')`,
		display: 'inline-block',
		width: 16,
		height: 16,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	warningIconSmall: {
		backgroundImage: `url('${YellowWarning}')`,
		display: 'inline-block',
		width: 22,
		height: 22,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	errorIconSmall: {
		backgroundImage: `url('${ErrorIcon}')`,
		display: 'inline-block',
		width: 18,
		height: 18,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},

	sentMessage: {
		lineHeight: 1.2,
		// backgroundColor: '#438AF6',
		border: '1px solid #999',
		borderRadius: 10,
		padding: 14,
		//color: 'white',
		whiteSpace: 'pre-line',
		maxWidth: '800px',
		marginTop: 5,
	},
	replyMessage: {
		lineHeight: 1.4,
		backgroundColor: '#e5e5e5',
		borderRadius: 10,
		padding: '8px 12px',
		color: '#222',
		position: 'relative',
		whiteSpace: 'pre-line',
	},
	replyStatus: {
		position: 'absolute',
		right: 7,
		top: 7,
		opacity: 0.9,
	},
	replyDate: {
		fontSize: 13,
		color: '#666',
		textAlign: 'left',
		marginBottom: 2,
		marginTop: 15,
		marginLeft: 3,
	},
	popover: {
		pointerEvents: 'none',
	},
	freshnessColor: {
		height: 12,
		width: 12,
		border: `.5px solid #aaa`,
		borderRadius: 2,
		display: 'inline-block',
		marginRight: 5,
	},
	submitButton: {
		fontSize: 16,
		borderRadius: '100px',
		padding: '15px 25px',
		textTransform: 'uppercase',
	},
});

class PricingRequestTriage extends FormComponent {
	constructor(props) {
		super(props);

		const pricingRequestId = _.get(this.props, ['match', 'params', 'pricingRequestId']);

		this.state = {
			pricingRequestId: parseInt(pricingRequestId, 10),
			isSavingOpen: false,
			isInvalidOpen: false,
			savingStatus: undefined,

			formFieldError: {},
		};
	}

	handleCommentPopoverOpen = (event, internalNote) => {
		this.setState({
			popoverComment: internalNote,
			commentPopoverAnchor: event.currentTarget,
		});
	};
	handleCommentPopoverClose = () => {
		this.setState({ commentPopoverAnchor: null });
	};

	componentDidMount() {
		const { pricingRequest, getPricingRequest } = this.props;
		const { pricingRequestId } = this.state;

		if (!pricingRequest) {
			getPricingRequest({
				params: {
					pricingRequestIds: [pricingRequestId],
				},
			});
		} else {
			const newState = this.fillForm();
			this.setState(newState);
		}
	}

	// eslint-disable-next-line no-unused-vars
	componentDidUpdate(prevProps) {
		if (_.isUndefined(prevProps.pricingRequest) && !_.isUndefined(this.props.pricingRequest)) {
			const newState = this.fillForm();
			this.setState(newState);
		}
	}

	fillForm = () => {
		const { pricingRequest } = this.props;
		if (!pricingRequest) {
			return {};
		}
	};

	closeSavingDialog = () => {
		this.setState({ isSavingOpen: false });
	};
	handleContinue = () => {
		const { vendorBillId } = this.state;
		this.props.history.push(`/billing/vendorBill/update/${vendorBillId}`);
	};

	/*
	handleCreateGasBuddyPrice = () => {
		const { pricingRequest } = this.state;
		const { showErrors, apIngestionResultGet } = this.props;
		this.setState({
			isSavingOpen: true,
			savingStatus: 'saving',
		});
	};
	*/

	replyStatusToIcon = (status) => {
		const { classes } = this.props;
		if (status === 'matched') {
			return <span className={classes.greenCheckedIconSmall} />;
		} else {
			return <span className={classes.errorIconSmall} />;
		}
	};

	handleAddPrice = () => {
		const { showErrors, addGasBuddyPrice, pricingRequest, updatePricingRequest } = this.props;
		//- Required fields
		const formFieldError = {};
		const errors = [];

		const _setError = (path, error) => {
			_.set(formFieldError, path, error);
			errors.push(error);
		};

		let fields = [{ path: 'gasBuddyPrice', display: 'Retail Price' }];
		fields.forEach((s) => {
			if (!_.get(this.state, s.path)) {
				_setError(s.path, `${s.display} is required`);
			}
		});

		if (!_.isEmpty(errors)) {
			this.setState({ formFieldError });
			return showErrors(errors);
		}

		const { gasBuddyPrice } = this.state;

		const params = {
			stationId: pricingRequest.stationId,
			gasBuddyPrice: parseFloat(gasBuddyPrice),
		};

		this.setState({
			isSavingOpen: true,
			savingStatus: 'saving',
		});

		addGasBuddyPrice({
			params,
			callback: (err, r) => {
				if (err) {
					showErrors(err);
					this.setState({
						savingStatus: 'done',
					});
					return;
				}

				const gasBuddyPriceId = _.first(r.gasBuddyPriceIds);

				if (!gasBuddyPriceId) {
					showErrors(['No retail price ID sent back']);
					this.setState({
						savingStatus: 'done',
					});
					return;
				}

				updatePricingRequest({
					params: {
						pricingRequestId: pricingRequest.pricingRequestId,
						status: 'issued',
						createdGasBuddyPriceId: gasBuddyPriceId,
					},
					callback: () => {
						if (err) {
							showErrors(err);
						}
						this.setState({
							savingStatus: 'done',
						});
					},
				});
			},
		});
	};

	handleMarkInvalid = () => {
		const { invalidatePricingRequest, pricingRequest } = this.props;
		invalidatePricingRequest({
			params: {
				pricingRequestId: pricingRequest.pricingRequestId,
				invalidReason: 'Marked invalid via triage',
			},
		});
	};

	closeSavingDialog = () => {
		this.setState({ onContinue: false });
	};

	continueSavingDialog = () => {
		this.props.history.push(`/retailPricing/pricingRequests/`);
	};

	render() {
		const { classes, pricingRequest, stationMap, userMap } = this.props;
		if (!pricingRequest) {
			return <div>Loading...</div>;
		}

		const {
			// pricingRequestId,
			createdByUserId,
			stationId,
			dateCreated,
			sentToMobileNumber,
			sentToRecipient,
			sentMessage,
			replies,
			status,
		} = pricingRequest;

		const station = stationMap[stationId] || { number: 'Missing' };
		const stationName = `${station.number} - ${station.name}`;
		const user = userMap[createdByUserId] || { firstName: 'Automatic' };

		let replyDisplay = 'none yet';
		if (!_.isEmpty(replies)) {
			replyDisplay = (
				<div style={{ maxWidth: 800 }}>
					{replies.map((reply) => {
						return (
							<div key={reply.dateCreated}>
								<div className={classes.replyDate}>
									From {sentToMobileNumber} @{moment(reply.dateCreated).format('M/D/YY h:mm a')}
								</div>
								<div className={classes.replyMessage}>
									{reply.message}
									<div
										className={classes.replyStatus}
										onMouseEnter={(event) => {
											this.handleCommentPopoverOpen(event, reply.statusMessage);
										}}
										onMouseLeave={this.handleCommentPopoverClose}
									>
										{this.replyStatusToIcon(reply.status)}
									</div>
								</div>
							</div>
						);
					})}
				</div>
			);
		}

		const alreadyTriaged = status !== 'triage';

		return (
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<FMPRegionHeader isTop={true} label={'Triage Pricing Request'} />
					<Paper className={classes.paper}>
						<Grid container spacing={4}>
							<Grid item xs={12}>
								{alreadyTriaged && (
									<div
										style={{
											marginBottom: 20,
											padding: 20,
											backgroundColor: '#eef',
											borderRadius: 4,
										}}
									>
										<strong>Request has been triaged.</strong>
										<div>Current Status : {_.startCase(status)}</div>
									</div>
								)}

								<FMPSectionHeader label="Request Info" isTop={true} />
								<div style={{ lineHeight: '1.7' }}>
									<div>
										<strong>Station</strong> : {stationName}
									</div>
									<div>
										<strong>Sent At:</strong> {moment(dateCreated).format('dddd, M/D/YY h:mm a')}
									</div>
									<div>
										<strong>Sent By:</strong> {user.firstName}
									</div>
									<div>
										<strong>Sent To:</strong> {sentToMobileNumber} ({sentToRecipient})
									</div>
								</div>
							</Grid>

							<Grid item xs={12}>
								<FMPSectionHeader label="Sent Message" isTop={true} />
								<div className={classes.sentMessage}>{sentMessage} </div>
							</Grid>

							<Grid item xs={12}>
								<FMPSectionHeader label="Replies" isTop={true} />
								{replyDisplay}
							</Grid>

							<Grid item xs={12} md={5}>
								<FMPSectionHeader label="Add New Price" />

								<Grid container spacing={4}>
									<FMPText {...this.setForm(`gasBuddyPrice`, 'Retail Price')} />

									<Grid item xs={12}>
										<Button
											variant="contained"
											color="primary"
											className={classes.submitButton}
											onClick={this.handleAddPrice}
										>
											Add Retail Price
										</Button>
									</Grid>
								</Grid>
							</Grid>

							<Grid item xs={12} md={1}>
								<div style={{ marginTop: 40 }}>- or -</div>
							</Grid>
							<Grid item xs={12} md={4}>
								<FMPSectionHeader label="Invalidate Request" />

								<p style={{ padding: 10, border: '1px solid #ddd', borderRadius: '5px' }}>
									If the reply does not contain a price or the request is too old to be useful then
									mark invalid.
								</p>
								<Button
									variant="contained"
									color="primary"
									onClick={this.handleMarkInvalid}
									className={classes.submitButton}
								>
									Mark Invalid
								</Button>
							</Grid>
						</Grid>

						<Popover
							id="comment-popover"
							className={classes.popover}
							classes={{ paper: classes.popOverPaper }}
							open={!!this.state.commentPopoverAnchor}
							anchorEl={this.state.commentPopoverAnchor}
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'left',
							}}
							transformOrigin={{
								vertical: 'top',
								horizontal: 'left',
							}}
							onClose={this.state.handleCommentPopoverClose}
							disableRestoreFocus
						>
							<div className={classes.commentsContainer}>
								{!!this.state.popoverComment && <div>{this.state.popoverComment}</div>}
							</div>
						</Popover>

						<GenericSavingDialog
							open={this.state.isSavingOpen}
							onClose={this.closeSavingDialog}
							onContinue={this.continueSavingDialog}
							processingText={'Adding price and updating pricing request...'}
							successText={'Pricing request updated. Click continue to return to Pricing Requests.'}
							status={this.state.savingStatus}
						/>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

PricingRequestTriage.propTypes = {
	pricingRequest: PropTypes.object,
	getPricingRequest: PropTypes.func.isRequired,
	addGasBuddyPrice: PropTypes.func.isRequired,
	updatePricingRequest: PropTypes.func.isRequired,
	invalidatePricingRequest: PropTypes.func.isRequired,

	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	GasBuddyPricesContainer,
	PricingRequestContainer,
])(PricingRequestTriage);
